export default "https://cdn-static.gokick.com/assets/be369b33e14920b1856d71de34d484ec78759d8a/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";